module.exports = __webpack_public_path__ + "img/8.16b9bf47.svg";